module.exports = __webpack_public_path__ + "static/media/HSP70_final_sequences.fc64d6df.fa";